import React__default from 'react';

// html entity unicode for &nbsp;
const nbsp = '\u00A0';
// React component
const Nbsp = () => React__default.createElement(React__default.Fragment, null, nbsp);

export { Nbsp, nbsp };
//# sourceMappingURL=Nbsp.js.map
